const BIEN_TYPE = {
    maison: 'Maison',
    appartement: 'Appartement'
}

const CLIENT_TYPE = {
    locataire: 'Locataire',
    proprietaire: 'Propriétaire'
}

const RESIDENCE_TYPE = {
    principale: 'Résidence principale',
    secondaire: 'Résidence secondaire',
}

const ABONNEMENT = {
    monthly: 'mensuel',
    annual: 'annuel',
    temporary: 'temporaire'
}

const OCCUPIED_STATUS = {
    pno: 'PNO non meublé',
    locataire:'Locataire',
    proprietaire: 'Propriétaire occupant'
}

const LOCATION_DURATION = {
    short: "Location en courte durée",
    long:"Location à l'année"
}

const CIVILITY = {
    monsieur: 'Monsieur',
    madame: 'Madame',
    societe: 'Société'
}

const PRODUCT = {
    MH: 'MH',
    PNO: 'PNO',
    MH_TEMPO: 'MH_TEMPO'
}

const STEP = {
    presentation: 'presentation',
    declaration: 'declaration',
    characteristic: 'characteristic',
    client_info: 'client info',
    options_price: 'options & price',
    recap: 'recap',
    payment: 'payment'
}

const STEPS = [
    STEP.presentation,
    STEP.declaration,
    STEP.characteristic,
    STEP.client_info,
    STEP.options_price,
    STEP.recap,
    STEP.payment
]

module.exports = {
    BIEN_TYPE,
    CLIENT_TYPE,
    RESIDENCE_TYPE,
    OCCUPIED_STATUS,
    ABONNEMENT,
    LOCATION_DURATION,
    CIVILITY,
    PRODUCT,
    STEP, 
    STEPS
}